import { Button, Card, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const HydraulicServicesModal = (props) => {
  const { t } = useTranslation();
  const title = t('hydraulicModalTitle');

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="h1">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('hydraulicModalDesc')}</p>
        <Card className="px-4">
          <ul>
            <li>{t('hydraulicService1')}</li>
            <li>{t('hydraulicService2')}</li>
            <li>{t('hydraulicService3')}</li>
            <li>{t('hydraulicService4')}</li>
          </ul>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.onHide(title)}>{t('getQuote')}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default HydraulicServicesModal;
